"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderFormInputs = exports.generateOptionsFromNumber = exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _padStart = _interopRequireDefault(require("lodash/padStart"));
var _config = _interopRequireDefault(require("../config"));
var _APInput = _interopRequireDefault(require("../components/common/APInput"));
var _APNumberInput = _interopRequireDefault(require("../components/common/APNumberInput"));
var _APSelect = _interopRequireDefault(require("../components/common/APSelect"));
var _APDatePicker = _interopRequireDefault(require("../components/common/APDatePicker/APDatePicker"));
var _APPhoneInput = _interopRequireDefault(require("../components/common/APPhoneInput"));
var _APDocumentUpload = _interopRequireDefault(require("../components/common/APDocumentUpload/APDocumentUpload"));
var _APImageUpload = _interopRequireDefault(require("../components/common/APImageUpload/APImageUpload"));
var _APUpload = _interopRequireDefault(require("../components/common/APUpload/APUpload"));
var _APTimePickerDropdown = _interopRequireDefault(require("../components/common/APTimePickerDropdown/APTimePickerDropdown"));
var _APDatePickerDropdown = _interopRequireDefault(require("../components/common/APDatePickerDropdown/APDatePickerDropdown"));
var _formValidations = require("./formValidations");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var renderFormInputs = exports.renderFormInputs = function renderFormInputs() {
  var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var customClass = arguments.length > 1 ? arguments[1] : undefined;
  var context = arguments.length > 2 ? arguments[2] : undefined;
  var change = arguments.length > 3 ? arguments[3] : undefined;
  var inputTypes = {
    text: renderInput,
    email: renderInput,
    number: renderNumberInput,
    select: renderSelect,
    date: renderDatePicker,
    timeDropdown: renderDatePickerDropdown,
    dateDropdown: renderTimePickerDropdown,
    phone: renderPhoneInput,
    image: renderImageUpload,
    document: renderDocumentUpload,
    country: renderCountry,
    upload: renderUpload
  };
  return fields.filter(function (field) {
    if (!inputTypes[field.type]) console.error("Unsupported ".concat(field.type, " input type on field: ").concat(field.name));
    return inputTypes[field.type];
  }).map(function (field) {
    return inputTypes[field.type](field, customClass, context, change);
  });
};
var renderInput = function renderInput(field, customClass, context) {
  var validators = getInputValidators(field);
  return /*#__PURE__*/_react["default"].createElement(_APInput["default"], {
    key: field.name,
    value: field.value,
    name: field.name,
    label: context.t(field.label),
    type: field.type,
    placeholder: context.t(field.placeholder),
    validate: validators,
    info: context.t(field.info),
    customClass: customClass
  });
};
var renderNumberInput = function renderNumberInput(field, customClass, context) {
  var validators = getInputValidators(field);
  return /*#__PURE__*/_react["default"].createElement(_APNumberInput["default"], {
    key: field.name,
    name: field.name,
    value: field.value,
    label: context.t(field.label),
    type: field.type,
    placeholder: context.t(field.placeholder),
    validate: validators,
    info: context.t(field.info),
    customClass: customClass
  });
};
var renderSelect = function renderSelect(field, customClass, context) {
  return /*#__PURE__*/_react["default"].createElement(_APSelect["default"], {
    key: field.name,
    name: field.name,
    label: context.t(field.label),
    type: field.type,
    info: context.t(field.info),
    customClass: customClass,
    options: Array.isArray(field.options) ? field.options.map(function (item) {
      return {
        value: item,
        label: context.t(item)
      };
    }) : Object.keys(field.options).map(function (prop) {
      return {
        value: prop,
        label: context.t(field.options[prop])
      };
    })
  });
};
var renderCountry = function renderCountry(field, customClass, context) {
  var options = _config["default"].Countries;
  var keys = Object.keys(_config["default"].Countries);
  if (field.whiteList) {
    options = keys.filter(function (country) {
      return field.whiteList.includes(options[country]);
    });
  } else if (field.blackList) {
    options = keys.filter(function (country) {
      return !field.blackList.includes(options[country]);
    });
  }
  field.options = options;
  return renderSelect(field, customClass, context);
};
var renderImageUpload = function renderImageUpload(field, customClass, context, change) {
  var validators = getInputValidators(field);
  return /*#__PURE__*/_react["default"].createElement(_APImageUpload["default"], {
    key: field.name,
    name: field.name,
    label: context.t(field.label),
    alt: field.alt ? context.t(field.alt) : context.t(field.label),
    info: context.t(field.info),
    customClass: customClass,
    validate: validators,
    placeholder: field.placeholder,
    maxSize: field.maxSize,
    onChange: change
  });
};
var renderDocumentUpload = function renderDocumentUpload(field, customClass, context, change) {
  var validators = getInputValidators(field);
  return /*#__PURE__*/_react["default"].createElement(_APDocumentUpload["default"], {
    key: field.name,
    name: field.name,
    label: context.t(field.label),
    info: context.t(field.info),
    customClass: customClass,
    validate: validators,
    placeholder: field.placeholder,
    maxSize: field.maxSize,
    onChange: change
  });
};
var renderUpload = function renderUpload(field, customClass, context, change) {
  var validators = getInputValidators(field);
  return /*#__PURE__*/_react["default"].createElement(_APUpload["default"], {
    key: field.name,
    name: field.name,
    label: context.t(field.label),
    info: context.t(field.info),
    customClass: customClass,
    validate: validators,
    placeholder: field.placeholder,
    maxSize: field.maxSize,
    acceptedFiles: field.acceptedFiles,
    customChange: change
  });
};
var renderDatePicker = function renderDatePicker(field, customClass, context) {
  var validators = getInputValidators(field);
  return /*#__PURE__*/_react["default"].createElement(_APDatePicker["default"], {
    key: field.name,
    name: field.name,
    label: context.t(field.label),
    type: field.type,
    info: context.t(field.info),
    validate: validators,
    customClass: customClass,
    maxDate: new Date()
  });
};
var renderDatePickerDropdown = function renderDatePickerDropdown(field, customClass, context) {
  var validators = getInputValidators(field);
  return /*#__PURE__*/_react["default"].createElement(_APDatePickerDropdown["default"], {
    key: field.name,
    name: field.name,
    label: context.t(field.label),
    info: context.t(field.info),
    validate: validators,
    customClass: customClass,
    maxDate: new Date(),
    leadingZero: field.leadingZero
  });
};
var renderTimePickerDropdown = function renderTimePickerDropdown(field, customClass, context) {
  var validators = getInputValidators(field);
  return /*#__PURE__*/_react["default"].createElement(_APTimePickerDropdown["default"], {
    key: field.name,
    name: field.name,
    label: context.t(field.label),
    type: field.type,
    info: context.t(field.info),
    validate: validators,
    customClass: customClass,
    leadingZero: field.leadingZero
  });
};
var renderPhoneInput = function renderPhoneInput(field, customClass, context) {
  var validators = getInputValidators(field);
  return /*#__PURE__*/_react["default"].createElement(_APPhoneInput["default"], {
    key: field.name,
    name: field.name,
    label: context.t(field.label),
    info: context.t(field.info),
    validate: validators,
    customClass: customClass
  });
};
var mapStringToValidators = {
  required: _formValidations.required,
  email: _formValidations.email,
  alphanumeric: _formValidations.alphanumeric,
  isDate: _formValidations.isDate,
  minLength: _formValidations.minLength,
  maxLength: _formValidations.maxLength,
  isValidPhone: _formValidations.isValidPhone,
  numeric: _formValidations.numeric
};
var getInputValidators = function getInputValidators(field) {
  if (!field.validators) return;
  var result = field.validators && field.validators.map(function (validator) {
    var _validator$split = validator.split(':'),
      _validator$split2 = _slicedToArray(_validator$split, 2),
      validatorName = _validator$split2[0],
      validatorArgs = _validator$split2[1];
    if (validatorArgs) {
      var passedArgs = validatorArgs.split(',');
      return mapStringToValidators[validatorName].apply(mapStringToValidators, _toConsumableArray(passedArgs));
    } else {
      return mapStringToValidators[validatorName];
    }
  });
  return result.filter(function (item) {
    return item;
  });
};
var generateOptionsFromNumber = exports.generateOptionsFromNumber = function generateOptionsFromNumber() {
  var min = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var max = arguments.length > 1 ? arguments[1] : undefined;
  var pad = arguments.length > 2 ? arguments[2] : undefined;
  var options = [];
  for (var i = min; i < max; i++) {
    options.push(/*#__PURE__*/_react["default"].createElement("option", {
      key: i,
      value: i
    }, (0, _padStart["default"])(i, pad, '0')));
  }
  return options;
};
var _default = exports["default"] = renderFormInputs;